import UIkit from 'uikit/dist/js/uikit-core.js';
import * as SlideshowMod from 'uikit/dist/js/components/slideshow.js';

const initCaseStudy = () => {
  const caseStudyContainer = document.querySelector('.case-study');

  if (caseStudyContainer) {
    if (window.outerWidth <= 960) {
      UIkit.util.ready(() => {
        const caseStudySlideshowContainer = document.querySelector('.case-study .uk-slideshow');
        const slideshowItems = caseStudySlideshowContainer?.querySelector('.uk-slideshow-items');
        slideshowItems.style.height = '1000px';

        UIkit.util.on(caseStudySlideshowContainer, 'itemshow', () => {
          const comp = UIkit.getComponent(caseStudySlideshowContainer, 'slideshow');
          const idx = (comp?.index ?? 0) + 1;

          const height = caseStudySlideshowContainer.querySelector(`.uk-slideshow-items > *:nth-child(${idx}) .case-study__item`)?.clientHeight ?? 0;
          slideshowItems.style.height = `${height + 50}px`;
        });
      });
    }
  }
};

export default initCaseStudy;
